import { AppAlertsState } from "@idw-types/state/app-alerts-state";
import { AppAlertsActionTypes, AppAlertsActions } from "../actions/app-alerts-actions";

export const initialAppAlertsState: AppAlertsState = {
    appAlerts: []
};

export const appAlertsReducer = (
    state: AppAlertsState = initialAppAlertsState,
    action: AppAlertsActions
): AppAlertsState => {
    switch (action.type) {
        case AppAlertsActionTypes.ADD_APP_ALERT:
            return {
                appAlerts: [...state.appAlerts, action.payload.appAlert]
            };
        case AppAlertsActionTypes.REMOVE_APP_ALERT:
            return {
                appAlerts: state.appAlerts.filter(alert => alert.id !== action.payload.appAlertId)
            };
        case AppAlertsActionTypes.CLEAR_APP_ALERTS:
            return {
                appAlerts: []
            };
        default:
            return state;
    }
};